import { SET_NEW_APP_STATE, UPDATE_APP_STATE } from './constants'

const initialState = {
    report: {
        activeType: null,
        ribbonActiveBlocks: {},
    },
    portfolio: {
        activeType: null,
        ribbonActiveBlocks: {},
    },
    exports: {
        jobs: {},
    },
}

export default (state = initialState, action = {}) => {
    switch (action.type) {
        case SET_NEW_APP_STATE: {
            const appState = action.data?.appState

            if (appState) return appState

            return state
        }
        case UPDATE_APP_STATE: {
            const moduleName = action.data?.moduleName
            const key = action.data?.key
            const value = action.data?.value

            const updatedAppState = {
                ...state,
                [moduleName]: {
                    ...state[moduleName],
                    [key]: value,
                },
            }

            return updatedAppState
        }
        default:
            return state
    }
}
